import useSWR from 'swr';
import axiosInstance from 'apis/axiosInstance';
import { loadSelectedClinicId } from 'utils/storage';
import { WeekServiceSchedule } from 'interfaces/serviceSchedule';

const useServiceSchedule = (serviceId: string) => {
  const clinicId = loadSelectedClinicId();

  const { data, error } = useSWR(
    [`/services/${serviceId}/schedules`, clinicId],
    async (...resource) => {
      const [url] = resource;
      const response = await axiosInstance.get<WeekServiceSchedule>(url);
      return response.data;
    }
  );

  return {
    data,
    error,
    isLoading: !data && !error,
  };
};

export default useServiceSchedule;
